import { render, staticRenderFns } from "./InsuranceCaseDetailsDrawer.vue?vue&type=template&id=7311170d"
import script from "./InsuranceCaseDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./InsuranceCaseDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports